var React = require('react');

function ExecutiveNetworkPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"executive-network","fill":"none","stroke":"rgb(9,31,42)","strokeWidth":"2","d":"M1,.05C8.18,138.58,52.08,290.59,210.21,290.59c290.5,0,330.5-196.5,581-70.5s261.5,182,438,102.5,238,91.5,248.5,228.5"}));
}

ExecutiveNetworkPath.defaultProps = {"viewBox":"0 0 1478.71 551.16"};

module.exports = ExecutiveNetworkPath;

ExecutiveNetworkPath.default = ExecutiveNetworkPath;
